
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GridGraphQL"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GridInterface"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseStorableGraphQL"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cells"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"container"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContainerNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContainerGraphQL"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InaccessibleInfoNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InaccessibleInfoGraphQL"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"columnIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"writable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"admin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appendable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archivable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unarchivable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canEditBarcodes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canEditNamesAndBarcodes"},"arguments":[],"directives":[]}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlateNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restrictionStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sampleRoles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SampleRolesGraphQL"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"writable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"admin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appendable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archivable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unarchivable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canEditBarcodes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canEditNamesAndBarcodes"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":741}};
    doc.loc.source = {"body":"fragment GridGraphQL on GridInterface {\n  ...BaseStorableGraphQL\n  cells {\n    container {\n      ... on ContainerNode {\n        ...ContainerGraphQL\n      }\n      ... on InaccessibleInfoNode {\n        ...InaccessibleInfoGraphQL\n      }\n    }\n    columnIndex\n    rowIndex\n  }\n\n  ... on BoxNode {\n    permissions {\n      readable\n      writable\n      admin\n      appendable\n      archivable\n      unarchivable\n      canEditBarcodes\n      canEditNamesAndBarcodes\n    }\n  }\n  ... on PlateNode {\n    restrictionStatus\n    sampleRoles {\n      ...SampleRolesGraphQL\n    }\n    permissions {\n      readable\n      writable\n      admin\n      appendable\n      archivable\n      unarchivable\n      canEditBarcodes\n      canEditNamesAndBarcodes\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GridGraphQL"] = oneQuery(doc, "GridGraphQL");
        
